import { Tab } from "../Tab";
import "./index.css";
import { useTranslation } from "react-i18next";

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header className="dashboard-widgets__header">
      <h1 className="dashboard-widgets__header-title heading-1">
        {t("label.build_ecommerce_of_the_future")}
      </h1>
      <Tab />
    </header>
  );
};
